import { createPostAsyncSlice } from '@sonar-software/xuder';
import { postInitiativeTaskOrder } from '@api';
import { updateInitiativeReferences } from '../../_idMap/actions';
import { call, select } from 'redux-saga/effects';
import { Task, TaskReorderRequest } from '@types';

const name = 'CoreInitiativesTasksOrder';

export const coreInitiativesTasksOrderPostAsyncSlice = createPostAsyncSlice<typeof name, TaskReorderRequest, void>({
	httpSagaOptions: {
		preRequestActionCreators: [
			({ initiativeId, sourceIndex, targetIndex }) =>
				updateInitiativeReferences([
					{
						initiativeId,
						tasks: {
							toReorderByIndex: {
								sourceIndex,
								targetIndex
							}
						}
					}
				])
		]
	},
	name,
	receive: false,
	request: true,
	requestHandler: function* requestHandler(request: TaskReorderRequest) {
		const tasks = ((yield select((state) => state.core.initiatives.byIdMap.data[ request.initiativeId ]?.tasks)) ??
			[]) as Array<Task>;

		return yield call(postInitiativeTaskOrder, {
			initiativeId: request.initiativeId,
			initiativeTaskOrder: tasks.map(({ initiativeTaskId, orderIndex }) => ({
				initiativeTaskId,
				orderIndex
			}))
		});
	}
});
